<template>
  <div class="analytics-data-table">
    <table cellspacing="0">
      <tr>
        <th></th>
        <th v-for="(s, i) in series" :key="i">{{ s.name }}</th>
      </tr>
      <tr v-for="(category, row) in categories" :key="row">
        <td class="category-cell">{{ cell(category) }}</td>
        <td v-for="(s, i) in series" :key="i">
          {{ cell(s.data[row]) }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
/**
 * The relief channel behind every ChartCard's Table toggle. Three of the
 * light-mode series colours sit below 3:1 contrast on white, which is only
 * acceptable when the same data is reachable without relying on hue - this
 * table is that path, not a nice-to-have.
 */
export default {
  name: 'AnalyticsDataTable',
  props: {
    categories: { type: Array, default: () => [] },
    series: { type: Array, default: () => [] },
  },
  methods: {
    cell(value) {
      if (value === null || value === undefined) return '—';
      // Multi-line axis categories arrive as arrays of lines (see the
      // open-checkouts panel); a table row wants them on one line.
      if (Array.isArray(value)) return value.join(' · ');
      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
.analytics-data-table {
  max-height: 320px;
  overflow-y: auto;

  table {
    width: 100%;
    font-size: 12px;
    color: #333333;
  }
  th {
    text-align: left;
    padding: 6px 10px;
    border-bottom: 2px solid #eceef0;
    position: sticky;
    top: 0;
    background: white;
  }
  td {
    padding: 5px 10px;
    border-bottom: 1px solid #eceef0;
  }
  .category-cell {
    color: #7a7f85;
  }
}
</style>
